<script setup lang="ts"></script>

<template>
	<router-view />
</template>

<style>
* {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
}

body {
	font-family:
		system-ui,
		-apple-system,
		sans-serif;
	background-color: #f5f5f5;
}
</style>
